import { getToken } from "@/utils/auth";
import service from "@/utils/request";

export const getAllUnits = async (page) => {
    try{
        const response = await service.get('/units?page='+page);
        return response;
    }catch(e){
        console.error("Failed to fetch Units:", e);
    }
}

export const deleteUnit = async (id) => {
    try{
        const response = await service.delete('/units/'+id);
        return response;
    }catch(e){
        console.error("Failed to delete Unit:", e);
    }
}

export const UpdateUnit = async ( unit) => {
    try{
        const response = await service.post('/units/'+unit.id , unit , {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response;
    }catch(e){
        console.error("Failed to update Unit:", e);
    }
}
export const addUnit = async (unit) => {
    try{
        const response = await service.post('/units', unit, {
            headers: {
                'Authorization': `Bearer ${getToken()}`,
                'Content-Type': 'multipart/form-data',  // Important for file uploads
            }
        });
        return response;
    }catch(e){
        console.error("Failed to update Unit:", e);
    }
}
export const search = async ( value , page) => {
    try{
        const response = await service.get('/search', {
            params: { page, value },
        });
        return response;
    }catch(e){
        console.error("Failed to update Unit:", e);
    }
}

const getUnitsPage = (response) => {
    const paginator = response?.data?.units ?? response?.data ?? response;
    return {
        items: Array.isArray(paginator?.data) ? paginator.data : [],
        lastPage: Number(paginator?.last_page) || 1,
    };
};

export const fetchAllSearchUnits = async (value) => {
    let page = 1;
    let lastPage = 1;
    const allUnits = [];

    do {
        const response = await search(value, page);
        const { items, lastPage: totalPages } = getUnitsPage(response);
        allUnits.push(...items);
        lastPage = totalPages;
        page += 1;
    } while (page <= lastPage);

    return allUnits;
};

export const fetchAllFilteredUnits = async (form) => {
    let page = 1;
    let lastPage = 1;
    const allUnits = [];

    do {
        const response = await filter(form, page);
        const { items, lastPage: totalPages } = getUnitsPage(response);
        allUnits.push(...items);
        lastPage = totalPages;
        page += 1;
    } while (page <= lastPage);

    return allUnits;
};

export const fetchAllUserUnits = async (id) => {
    const response = await userUnits(id);
    const { items } = getUnitsPage(response);
    return items;
};

export const filter = async ( form , pageno) => {
    try{
        const response = await service.post('/filter-units' , {values:form , page:pageno});
        return response;
    }catch(e){
        console.error("Failed to update Unit:", e);
    }
}

export const userUnits = async (id) => {
    try{
        const response = await service.get('/user-units/'+id);
        return response;
    }catch(e){
        console.error("Failed to update Unit:", e);
    }
}

export const exportUnits = async () => {
    try {
        const response = await service.get('/export-units', { timeout: 60000 });
        return response;
    } catch (e) {
        console.error("Failed to export units:", e);
        throw e;
    }
}